// src/hooks/useLocationSelector.ts
import { useState, useEffect } from 'react';
import useLocations from '@hooks/useLocations';
const ALL_LOCATIONS_ID = 'ALL_LOCATIONS';
const useLocationSelector = () => {
    const { data: locations, isLoading, error } = useLocations();
    // Initialize selectedLocationId from localStorage or default to 'ALL_LOCATIONS'
    const [selectedLocationId, setSelectedLocationId] = useState(() => {
        return localStorage.getItem('selectedLocationId') || ALL_LOCATIONS_ID;
    });
    // Persist selectedLocationId to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('selectedLocationId', selectedLocationId);
    }, [selectedLocationId]);
    // Automatically set selectedLocationId if there's only one location
    useEffect(() => {
        if (locations && locations.length === 1) {
            const singleLocationId = locations[0].id;
            if (selectedLocationId !== singleLocationId) {
                setSelectedLocationId(singleLocationId);
            }
        }
    }, [locations, selectedLocationId]);
    // Extract all location IDs for potential future use
    const allLocationIds = locations === null || locations === void 0 ? void 0 : locations.map((location) => location.id);
    // Determine if 'ALL_LOCATIONS' is selected
    const isAllLocationsSelected = selectedLocationId === ALL_LOCATIONS_ID;
    const locationSelectorProps = {
        selectedLocationId,
        setSelectedLocationId,
        locations: locations || [],
    };
    return {
        locationSelectorProps,
        allLocationIds,
        isAllLocationsSelected,
        isLoading,
        error,
    };
};
export default useLocationSelector;
